import { api } from '@/lib/api';
import type {
  CategoryWithUsage,
  CreateCategoryInput,
  ProductCategory,
  UpdateCategoryInput,
} from './types';

/** Every category, retired ones included, with what is filed under each. */
export async function fetch_categories(): Promise<CategoryWithUsage[]> {
  const res = await api.get<{ items: CategoryWithUsage[] }>('/admin/product-categories');
  return res.data.items;
}

export async function create_category(input: CreateCategoryInput): Promise<ProductCategory> {
  const res = await api.post<ProductCategory>('/admin/product-categories', input);
  return res.data;
}

export async function update_category(
  id: string,
  input: UpdateCategoryInput,
): Promise<ProductCategory> {
  const res = await api.patch<ProductCategory>(`/admin/product-categories/${id}`, input);
  return res.data;
}

/** Refused by the server when anything is filed under it — retire instead. */
/** Upload artwork, then attach the returned key to a category. Mirrors the banner flow. */
export async function upload_category_icon(file: File): Promise<{ icon_s3_key: string }> {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post<{ icon_s3_key: string }>('/admin/product-categories/icon', form);
  return res.data;
}

export async function delete_category(id: string): Promise<void> {
  await api.delete(`/admin/product-categories/${id}`);
}
